<template>
  <component :is="dialogContent" :parent-data="parentData"/>
</template>

<script>


import PrcHandle from "@/views/applications/oa/PrcHandleOld.vue";
import PrcHandleTab from "@/views/applications/oa/PrcHandleTab.vue";
import PrcMonthReimburse from "./MonthReimburse.vue";

export default {
  name: "PrcHandleContainer",
  inject: ['$fn'],
  components: {
    PrcHandle,PrcHandleTab,PrcMonthReimburse
  },
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath: false,
        value: 'type',
        label: 'name'
      }
    }
  },
  methods: {},
  computed: {
    dialogContent() {
      switch (this.parentData.template_id) {
        case 'prc_business_trip':
          return PrcHandleTab;
        case 'prc_reimburse_apply':
          return PrcMonthReimburse;
        default:
          return PrcHandle;
      }
    },
  },
}
</script>

<style scoped lang="less">

</style>